// Shared bits for the bidder's "My auctions" pages (dashboard, won, bids,
// watchlist) so labels and styling stay consistent across the split pages.
import { toImageArray } from "../../common/format";
import { t } from "./auctionI18n";

export const INVOICE_TONE = { unpaid: "is-not", paid: "is-met", cancelled: "is-cancelled", overdue: "is-not" };

// Invoice status label in the active language.
export const invoiceStatusLabel = (status) => ({
    unpaid: t("გადაუხდელი", "Unpaid", "Не оплачен", "Չվճարված"),
    paid: t("გადახდილი", "Paid", "Оплачен", "Վճարված"),
    cancelled: t("გაუქმებული", "Cancelled", "Отменён", "Չեղարկված"),
    overdue: t("ვადაგადაცილებული", "Overdue", "Просрочен", "Ժամկետանց"),
}[status] || status);

// Result label + tone for a bid-history row (mirrors the server's `result`).
const RESULT_CLS = {
    leading: "is-me", outbid: "is-outbid", won: "is-won",
    pending: "is-pending", countered: "is-pending", lost: "is-lost",
};
export const resultInfo = (result) => ({
    label: {
        leading: t("ლიდერი", "Leading", "Лидер", "Առաջատար"),
        outbid: t("გადაგაჭარბეს", "Outbid", "Перебита", "Գերազանցված"),
        won: t("მოგებული", "Won", "Выиграно", "Շահած"),
        pending: t("განხილვაშია", "Under review", "На рассмотрении", "Քննարկման մեջ"),
        countered: t("შემოთავაზებაა", "Counter-offer", "Встречное", "Հակաառաջարկ"),
        lost: t("ვერ მოიგეთ", "Lost", "Проиграно", "Պարտված"),
    }[result] || result,
    cls: RESULT_CLS[result] || "",
});

export const thumbStyle = (images) => {
    const img = toImageArray(images)[0];
    return img ? { backgroundImage: `url('${img}')` } : {};
};
